import { createAction } from 'typesafe-actions';

import { Annotations } from '../constants';

interface RequestAnnotateAesopObjectsParams {
  pandoraIds: $TSFixMe;
  withProgress: boolean | $TSFixMe;
  dedupeAnnotationsRequest: boolean | $TSFixMe; // check if undefined/optional
  ignoreAnnotations: boolean | $TSFixMe; // check if undefined/optional
}

export const requestAnnotateAesopObjects = createAction(
  Annotations.ActionTypes.REQUEST_ANNOTATE_AESOP_OBJECTS,
  ({
    pandoraIds,
    withProgress = true,
    dedupeAnnotationsRequest = false,
    ignoreAnnotations = false,
  }) => ({
    pandoraIds,
    withProgress,
    // If true, dedupeAnnotationsRequest will exclude episodes that already have annotations
    dedupeAnnotationsRequest,
    // If true, ignoreAnnotations will prevent the actual annotations returned from Aesop
    // from being stored in state. We'll only store 'progress' and 'newEpisodeBadge' data
    ignoreAnnotations,
  }),
)<RequestAnnotateAesopObjectsParams>();
export type RequestAnnotateAesopObjectsAction = ReturnType<typeof requestAnnotateAesopObjects>;

interface EnsureFullDataPayload {
  ids: $TSFixMe[];
  idVerifier: $TSFixMeFunction;
  idFetcher: $TSFixMeFunction;
}

export const ensureFullDataActionCreator = (
  idVerifier: $TSFixMe,
  idFetcher: $TSFixMe,
): ReturnType<
  ReturnType<typeof createAction<string, EnsureFullDataPayload, undefined, $TSFixMe>>
> =>
  createAction(Annotations.ActionTypes.ENSURE_FULL_DATA, (ids: $TSFixMe) => ({
    ids,
    idVerifier,
    idFetcher,
  }))<EnsureFullDataPayload>();
export type EnsureFullDataAction = ReturnType<ReturnType<typeof ensureFullDataActionCreator>>;

interface AnnotateIdsPayload {
  ids: $TSFixMe[];
  annotateAlbumTracks: boolean | $TSFixMe;
}

export const annotateIds = createAction(
  Annotations.ActionTypes.ANNOTATE_IDS,
  (ids: $TSFixMe = [], annotateAlbumTracks = true) => ({ ids, annotateAlbumTracks }),
)<AnnotateIdsPayload>();

type OverwriteAnnotationsParams = $TSFixMe;
interface OverwriteAnnotationsPayload {
  annotations: OverwriteAnnotationsParams;
}
export const overwriteAnnotations = createAction(
  Annotations.ActionTypes.OVERWRITE_ANNOTATIONS,
  (annotations: OverwriteAnnotationsParams) => ({ annotations }),
)<OverwriteAnnotationsPayload>();
export type OverwriteAnnotationsAction = ReturnType<typeof overwriteAnnotations>;
